export default __webpack_public_path__ + "static/media/checklist-check-list-marker.00012f25.jpg";